import React, { type PropsWithChildren, type FC } from 'react';

import { type Interpolation } from '@emotion/react';

import reactHTMLParser from '../../../utils/reactHTMLParser';
import Text, { type TextProps } from '../../text/text';
import type { Lucid } from '../../../types/types';

export type CardTextProps = TextProps & {
  /** Allows the Card Text to receive additional styles */
  css?: Interpolation<Lucid.Theme.Brand>;
  /** The string value to be passed as the Text inner HTML */
  value?: string;
  /** An HTML string that will be run through the HTML parser */
  html?: string;
  /** The Text variant */
  variant?: Exclude<
    TextProps['variant'],
    Lucid.Theme.Component.Typography.Hero.VariantKeys | Lucid.Theme.Component.Typography.Heading.VariantKeys
  >;
};

const CardText: FC<PropsWithChildren<CardTextProps>> = ({ value, html, className, children, ...rest }) => {
  const returnString = value ?? (html ? reactHTMLParser(html, { replaceOptions: { replaceTag: 'span' } }) : undefined);

  return (
    returnString && (
      <Text
        {...rest}
        css={{ label: 'cardText' }}
        // eslint-disable-next-line @stylistic/jsx-sort-props
        className={className}
        data-card-element="text"
        variant="paragraphS400"
      >
        {returnString}
        {children}
      </Text>
    )
  );
};

export { CardText };
export default CardText;
